export const DEFAULT_FOLDER_MODAL_TEST_ID = 'folder-modal'
export const DEFAULT_CONFIRM_CTA_TEXT = 'Save'
export const DEFAULT_FOLDER_DATA = { name: '', public: false, id: null }
